import { BANK_STATS } from 'redux/actions/actiontype';
import {
  VIEW_ALL_BANKS,
  CREATE_USER_ACCOUNT,
  CHANGE_APPLICATION_STATUS,
  DOWNLOAD_DOCUMENT,
  GET_ORGANIZATIONS,
  REFRESH_TOKEN,
} from '../../actionTypes';

const initialState = {};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case VIEW_ALL_BANKS:
      return { ...state, allBanks: payload };
    case CREATE_USER_ACCOUNT:
      return { ...state, newUser: payload };
    case CHANGE_APPLICATION_STATUS:
      return { ...state, applicationStatus: payload };
    case BANK_STATS:
      return { ...state, bankStats: payload };
    case DOWNLOAD_DOCUMENT:
      return { ...state, downloadedDoc: payload };
    case GET_ORGANIZATIONS:
      return { ...state, allOrganisations: payload };
    default:
      return state;
  }
};
